<app-bread-crumb-options></app-bread-crumb-options>
<div class="container">
    <div class="tab-form-header pt-md-5">For your privacy, you need to create a secure login</div>
    <form [formGroup]="signUpForm" novalidate>
        <div class="row">
            <div class="card col-md-6 col-sm-6 col-xs-6  m-auto border-radius-10 border-0 shadow-sm p-2">
                <div class="card-body pb-1">
                    <div class="pb-3">
                        <label class="form-label" for="signup-fullname">Full Name</label>
                        <input id="signup-fullname" autocomplete="off" class="form-control form-input p-2" [(ngModel)]="signup.firstName"
                            formControlName="firstName"
                            data-testid="get-started.signup.full-name-input">
                        <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.firstName.errors?.required">Name is mandatory</div>
                            <div *ngIf="formControl.firstName.errors?.usernameExists">Please enter your first and last
                                name.
                            </div>
                        </div>
                    </div>
                    <div class="pb-3">
                        <label class="form-label">Phone Number</label>
                        <span class="float-end">
                            <label>
                                <input name="phoneType" type="radio" class="me-1" [(ngModel)]="signup.phoneType"
                                    formControlName="phoneType" [value]="3"
                                    data-testid="get-started.signup.phone-type-mobile-radio" />
                                <span class="cursor-pointer pe-2">Mobile</span>
                            </label>
                            <label>
                                <input name="phoneType" type="radio" class="me-1" [(ngModel)]="signup.phoneType"
                                    formControlName="phoneType" [value]="1"
                                    data-testid="get-started.signup.phone-type-home-radio">
                                <span class="cursor-pointer padding-right-5">Home</span>
                            </label>
                        </span>
                        <input autocomplete="off" class="form-control form-input p-2" [(ngModel)]="signup.phoneNumber"
                            id="phone-number" formControlName="phoneNumber" appPhoneMask
                            data-testid="get-started.signup.phone-number-input" />
                        <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.phoneNumber.errors?.required">Phone number is mandatory.</div>
                            <div *ngIf="formControl.phoneNumber.errors?.invalidPhoneLength">Phone number must be at least 10 digits.</div>
                        </div>
                    </div>
                    <div class="pb-3" *ngIf="showConsentCheckbox && !textMessageConsent">
                        <input class="me-1" formControlName="consent"
                        [(ngModel)]="signup.agreed_to_receive_text_message" type="checkbox"
                        id="signup-consent-1"
                        data-testid="get-started.signup.consent-checkbox">
                        I consent to communications by text message from <b>{{firmName}}</b>. You may opt-out by replying STOP or ask for more information by replying HELP. Message and data rates may apply. You may review our Privacy Policy at  <a href="{{firmWebsite}}">{{firmWebsite}}</a>  to learn how your data is used.
                        <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.consent.errors?.required">Please confirm.</div>
                        </div>
                    </div>
                    <div class="pb-3" *ngIf="showConsentCheckbox && textMessageConsent">
                        <input class="me-1" formControlName="consent"
                        [(ngModel)]="signup.agreed_to_receive_text_message" type="checkbox"
                        id="signup-consent-2"
                        data-testid="get-started.signup.consent-custom-checkbox">
                        {{textMessageConsent}}
                        <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.consent.errors?.required">Please confirm.</div>
                        </div>
                    </div>
                    <div class="pb-3">
                        <label class="form-label" for="signup-email">Email</label>
                        <input id="signup-email" autocomplete="off" class="form-control form-input p-2" [(ngModel)]="signup.email"
                            formControlName="email" autocomplete="false"
                            data-testid="get-started.signup.email-input">
                        <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.email.errors?.required">Email is mandatory.</div>
                            <div *ngIf="formControl.email.errors?.pattern">Enter a valid email.</div>
                        </div>
                    </div>
                    <div class="pb-3">
                        <label class="form-label" for="signup-password">Password</label>
                        <input id="signup-password" type="password" autocomplete="off" class="form-control form-input p-2" appTogglePassword
                            [(ngModel)]="signup.password" formControlName="password" autocomplete="false"
                            data-testid="get-started.signup.password-input">
                        <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.password.errors?.required">Password is mandatory.</div>
                        </div>
                        <div *ngIf="signUpFormSubmitted && invalid.length>0" class="text-danger" role="alert">
                            <div *ngFor="let error of invalid">{{error}}</div>
                        </div>
                    </div>
                    <div class="pb-3">
                        <label class="form-label" for="signup-confirm-password">Confirm Password</label>
                        <input id="signup-confirm-password" type="password" autocomplete="off" class="form-control form-input p-2"
                            [(ngModel)]="signup.confirmPassword" formControlName="confirmPassword" appTogglePassword autocomplete="false"
                            data-testid="get-started.signup.confirm-password-input">
                        <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.confirmPassword.errors?.required">Password is mandatory.</div>
                            <div *ngIf="formControl.confirmPassword.errors?.invalidMatch">Password does not match.</div>
                        </div>
                    </div>
                    <label class="form-label text-uppercase">Password must contain the following:</label>
                    <div>
                        <i class="fa fa-check color-green" *ngIf="!signUpForm.controls['password'].hasError('hasSmallCase')" aria-hidden="true"></i>
                        <i class="fa fa-times color-red me-2" *ngIf="signUpForm.controls['password'].hasError('hasSmallCase')" aria-hidden="true"></i>
                        <label [ngClass]="{'color-red':signUpForm.controls['password'].hasError('hasSmallCase'), 'color-green':!signUpForm.controls['password'].hasError('hasSmallCase')}">A <b>lowercase</b> letter</label>
                    </div>
                    <div>
                        <i class="fa fa-check color-green" *ngIf="!signUpForm.controls['password'].hasError('hasCapitalCase')" aria-hidden="true"></i>
                        <i class="fa fa-times color-red me-2" *ngIf="signUpForm.controls['password'].hasError('hasCapitalCase')" aria-hidden="true"></i>
                        <label [ngClass]="{'color-red':signUpForm.controls['password'].hasError('hasCapitalCase'), 'color-green':!signUpForm.controls['password'].hasError('hasCapitalCase')}">An <b>uppercase</b> letter</label>
                    </div>
                    <div>
                        <i class="fa fa-check color-green" *ngIf="!signUpForm.controls['password'].hasError('hasNumber')" aria-hidden="true"></i>
                        <i class="fa fa-times color-red me-2" *ngIf="signUpForm.controls['password'].hasError('hasNumber')" aria-hidden="true"></i>
                        <label [ngClass]="{'color-red':signUpForm.controls['password'].hasError('hasNumber'), 'color-green':!signUpForm.controls['password'].hasError('hasNumber')}">A <b>number</b></label>
                    </div>
                    <div>
                        <i class="fa fa-check color-green" *ngIf="!signUpForm.controls['password'].hasError('hasSpecialCharacters')" aria-hidden="true"></i>
                        <i class="fa fa-times color-red me-2" *ngIf="signUpForm.controls['password'].hasError('hasSpecialCharacters')" aria-hidden="true"></i>
                        <label [ngClass]="{'color-red':signUpForm.controls['password'].hasError('hasSpecialCharacters'), 'color-green':!signUpForm.controls['password'].hasError('hasSpecialCharacters')}">A <b>special</b> character</label>
                    </div>
                    <div>
                        <i class="fa fa-check color-green" *ngIf="!signUpForm.controls['password'].hasError('minlength') && signup.password" aria-hidden="true"></i>
                        <i class="fa fa-times color-red me-2" *ngIf="signUpForm.controls['password'].hasError('minlength') || !signup.password" aria-hidden="true"></i>
                        <label  [ngClass]="{'color-red':signUpForm.controls['password'].hasError('minlength') || !signup.password, 'color-green':!signUpForm.controls['password'].hasError('minlength') && signup.password}">Minimum <b>8 characters</b></label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pb-3">
            <div class="col-md-6 col-sm-6 col-xs-6  m-auto pt-3 ps-0">
                <input class="styled-checkbox" id="styled-checkbox-1" formControlName="terms"
                    [(ngModel)]="signup.terms_and_conditions" type="checkbox" required
                    data-testid="get-started.signup.terms-checkbox">Terms and conditions
                must be acknowledged
                <label for="styled-checkbox-1">I acknowledge that I have read and agree to the
                    <a href="{{firm.terms_of_service_url}}" target="_blank"
                        data-testid="get-started.signup.terms-of-service-link">Terms of Service</a> and have received {{firm.name}}'s <a
                        href="{{firm.form_adv_url}}" target="_blank"
                        data-testid="get-started.signup.form-adv-link">Form CRS, Form ADV 2A,</a> and all relevant <a
                        href="{{firm.disclosures_url}}" target="_blank"
                        data-testid="get-started.signup.disclosures-link">Disclosures.</a></label>
                <div *ngIf="signUpFormSubmitted" class="text-danger" role="alert">
                    <div *ngIf="formControl.terms.errors?.required">Terms and conditions must be acknowledged.</div>
                </div>
            </div>
        </div>

        <div class="text-center border-top p-4">
            <button class="btn btn-primary rounded-pill btn-lg-custom" (click)="submitSignUp()"
                data-testid="get-started.signup.submit-btn">
                Establish your profile
                <i class="fa fa-long-arrow-right btn-arrow-right" aria-hidden="true"></i>
            </button>
        </div>

    </form>
</div>
